import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    DialogContentText,
    Button
} from "@mui/material";

const ConfirmationDialog = ({
    open,
    onClose,
    onConfirm,
    title = "Confirm Action",
    message,
    confirmButtonText = "Confirm",
    cancelButtonText = "Cancel",
    confirmButtonColor = "error",
    isLoading = false
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button 
                    onClick={onClose}
                    variant="outlined"
                    disabled={isLoading}
                >
                    {cancelButtonText}
                </Button>
                <Button 
                    onClick={onConfirm}
                    variant="contained"
                    color={confirmButtonColor}
                    autoFocus
                    disabled={isLoading}
                >
                    {confirmButtonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog; 